package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class EventsNoticesAnalyticsResponse(
    val timestamp: String = "",
    val scope: String = "",
    @SerialName("upcoming_events")
    val upcomingEvents: List<UpcomingEventSummary> = emptyList(),
    @SerialName("recent_notices")
    val recentNotices: List<RecentNoticeSummary> = emptyList()
)

@Serializable
data class UpcomingEventSummary(
    val id: String = "",
    val title: String = "",
    val description: String? = null,
    @SerialName("event_date")
    val eventDate: String = "",
    @SerialName("event_type")
    val eventType: String = ""
)

@Serializable
data class RecentNoticeSummary(
    val id: String = "",
    val title: String = "",
    val content: String? = null,
    @SerialName("notice_type")
    val noticeType: String = "",
    val priority: String = "",
    @SerialName("created_at")
    val createdAt: String = ""
)
